module.exports = __webpack_public_path__ + "img/mike.fb096e4f.gif";